'use strict';

function spaceSplit(str) {
  return str.split(' ');
}

module.exports = spaceSplit;


//////////////////
// WEBPACK FOOTER
// ./~/sugar/common/internal/spaceSplit.js
// module id = 46
// module chunks = 0